import * as React from 'react';
import { FC } from 'react';

import { t } from 'state/intl/translations';

import BaseReceiptHeadInfo from './receipt-head-info.base';
import { Title } from './receipt-head-info.styled';
import { IOrderHeaderProps } from './types';

const ReceiptHeadInfo: FC<React.PropsWithChildren<IOrderHeaderProps>> = ({ order }) => {
  const message = t('orderDetailsHeading');
  return (
    <>
      <Title accessibilityLabel={message}>{message}</Title>
      <BaseReceiptHeadInfo order={order} />
    </>
  );
};

export default ReceiptHeadInfo;
